import Cookies from 'js-cookies';

export default function acceptCookiesModule() {
  const banner = jQuery('.accept-cookies');
  const isAccepted = Cookies.getItem('accept');
  if (isAccepted) {
    return;
  }
  banner.show();
  banner.find('button').click(() => {
    Cookies.setItem('accept', 'true');
    banner.hide();
  });
}



// WEBPACK FOOTER //
// ./scripts/modules/accept-cookies.js